import { NgModule, Component, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';

@Component({
    selector: 'marquee-cell',
    templateUrl: 'marquee-cell.template.html',
    styleUrls: ['marquee-cell.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarqueeCell {
    @Input() item: any;
    @Input() title: string;
    @Input() subtitle: string;
    @Input() subhead: string;
    @Input() tag: any;
    @Input() images: any;
    @Input() direction: string;
    @Input() ishover: boolean;
    @Input() cta: string;
    @Input() snipe: any;
    @Input() logo: "string";
    @Input() counts: "string";
    @Input() route: string;
    @Input() disable: boolean = false;
    @Input() meta: any;
    @Input() externalLink: string;
    @Input() target: string;
    @Input() isFull: boolean;
    public el: ElementRef;
    // private _hideImage:boolean = false;
    // private currentTime:number = 0;
    // public videoState:string = "in";
    // public videoSource:string;

    // public get showVideo():boolean{
    //     if(this.meta && (this.meta.video || this.meta.video_types))
    //     {
    //         this.videoSource = this.meta.video ? this.meta.video.meta.video_types : this.meta.video_types;
    //         return true;
    //     }

    //     return false;
    // }

    // public set hideImage(val:boolean){
    //     if(val)
    //     {
    //         this.videoState = "in";
    //     }

    //     this._hideImage = val;
    // }

    // public get hideImage():boolean{
    //     return this._hideImage;
    // }

    // public handleAnimationComplete(val:boolean) {
    //     this.hideImage = !val;
    // }



    /**
     * Marquee Component
     */
    constructor(el: ElementRef) {
        this.el = el;
        this.direction = "left";
        //this.subtitle = "Search the list of men and women who helped shape Chickasaw history."
    }

    ngOnChanges(changes){
        this.item = {
            title: this.title,
            subtitle: this.subtitle,
            subhead: this.subhead,
            tag: this.tag,
            images: this.images,
            direction: this.direction,
            ishover: this.ishover,
            snipe: this.snipe,
            logo: this.logo,
            counts: this.counts,
            route: this.route,
            disable: this.disable,
            meta: this.meta,
            url: this.externalLink,
            target: this.target
        }
        this.item.seriesInfo = this.getSeriesInfo(this.item.meta);
        this.item.cta = this.marqueeCta;
        //console.log(changes)
    }

    ngOnInit() {
        if (!this.item) {
            this.item = {
                title: this.title,
                subtitle: this.subtitle,
                subhead: this.subhead,
                tag: this.tag,
                images: this.images,
                direction: this.direction,
                ishover: this.ishover,
                snipe: this.snipe,
                logo: this.logo,
                counts: this.counts,
                route: this.route,
                disable: this.disable,
                meta: this.meta,
                url: this.externalLink,
                target: this.target
            }
        }
        this.item.seriesInfo = this.getSeriesInfo(this.item.meta);
        this.item.cta = this.marqueeCta;
    }

    private getSeriesInfo(meta) {
        if (!meta) return; 
        
        let info = "";
        if (meta.episode) {
            info = meta.episode.title;
        }
        else if (meta.series) {
            info = `${meta.series.title} | ${meta.sub_head}`;
        }
        else if(meta.job_title){
            info = meta.job_title;
        }
        else {
            info = meta.sub_head;
        }
        let runtime = meta.runtime || (meta.video && meta.video.runtime);
        if (runtime) {
            info = `${info} • ${runtime}`;
        }

        return info;
    }

    // public rollCell(){
    //     if(this.showVideo)
    //     {
    //         this.hideImage = true;
    //     }
    // }


    get marqueeObjType(): string {
        return this.item && ((this.item.meta || this.item).obj_type || "").toLowerCase();
    }

    get marqueeCta(): string {
        return ['video', 'episode'].indexOf(this.marqueeObjType) > -1 ? "play" : this.marqueeObjType;
    }

}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/marquee/marquee-cell/marquee-cell.component.ts